/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_FailedInputs */



/**
* | output |
* | --- |
* | "Speaking your message did not work. Type it or try again." |
*
* @param {Chat_Dictate_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_failed = /** @type {((inputs?: Chat_Dictate_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Inspreken lukte niet. Typ je bericht of probeer opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La dictée n'a pas fonctionné. Écrivez votre message ou réessayez.")
	return /** @type {LocalizedString} */ ("Speaking your message did not work. Type it or try again.")
});